import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { useCan } from '../hooks/useCan'

// Can renders its children only usable when the role holds `perm`. Without the
// permission they stay visible but inert and greyed out, with the missing
// permission as tooltip — the user sees what exists and why it is unavailable,
// instead of confirming a dialog and then getting a 403.
export default function Can({ perm, children }: { perm: string; children: ReactNode }) {
  const { t } = useTranslation()
  const allowed = useCan(perm)
  if (allowed) return <>{children}</>
  return (
    <span
      inert
      title={t('common.needsPerm', 'Dafür fehlt deiner Rolle das Recht {{perm}}', { perm })}
      style={{ display: 'inline-block', opacity: 0.45, cursor: 'not-allowed' }}
    >
      {children}
    </span>
  )
}
